import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/index')
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/index')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
